module.exports = __webpack_public_path__ + "img/csr_110923_I.228d32d4.jpg";